import React, { useState, Fragment } from 'react'
import styled from 'styled-components'
import TextAreaInput from '../Inputs/TextArea'
import TextInput from '../Inputs/Text'
import Query from './Query'
import Button from '../Button'
import Select from '../Inputs/Select'
import { exception } from '../../helpers/analytics'

const FORM_URL = process.env.GATSBY_CONTACT_FORM_URL

const Form = styled.form``

const InputGroup = styled.div`
  margin: 3rem 0;
  text-align: ${({ align }) => align || 'left'};
`

const DEFAULT_VALUES = {
  name: '',
  email: '',
  subject: 'general',
  message: ''
}

const GenericError = styled.p`
  color: ${({ theme }) => theme.colors.fail};
`

const Successful = styled.div`
  margin: 6rem 0;
`

export default () => {
  const [values, setValues] = useState(DEFAULT_VALUES)
  const [errors, setErrors] = useState({})
  const [genericError, setGenericError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [successful, setSuccessful] = useState(false)

  const onValueChange = (key) => (e) => {
    setValues({
      ...values,
      [key]: e.target.value
    })

    const newErrors = { ...errors }
    delete newErrors[key]
    setErrors(newErrors)
    setGenericError(false)
  }

  const onSubmit = async (e, content) => {
    console.log(content.field_required)

    e.preventDefault()
    setErrors({})
    setGenericError(false)
    const validationErrors = {}
    // Validate
    if (!values.name)
      validationErrors.name = content.contact_form.field_required
    if (!values.message)
      validationErrors.message = content.contact_form.field_required
    if (!values.email)
      validationErrors.email = content.contact_form.field_required
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }

    setIsLoading(true)
    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: values.name,
          message: values.message,
          email: values.email,
          subject: values.subject || DEFAULT_VALUES.subject
        })
      })

      setIsLoading(false)
      if (response.status === 200) setSuccessful(true)
      else setGenericError(true)
    } catch (err) {
      exception({
        description: 'Error submitting contact form',
        fatal: false,
        args: [],
        error: err
      })
      setIsLoading(false)
      setGenericError(true)
    }
  }

  return (
    <Query
      render={(content) => (
        <Fragment>
          {successful && (
            <Successful>
              <p>{content.contact_form.thank_you_response}</p>
            </Successful>
          )}
          {!successful && (
            <Form onSubmit={(e) => onSubmit(e, content)} action={FORM_URL}>
              <InputGroup>
                <TextInput
                  error={errors.name}
                  value={values.name}
                  onChange={onValueChange('name')}
                  label={content.contact_form.name_label}
                  name="name"
                  inputProps={{
                    required: true,
                    disabled: isLoading
                  }}
                  limitWidth={false}
                />
              </InputGroup>
              <InputGroup>
                <TextInput
                  error={errors.email}
                  value={values.email}
                  onChange={onValueChange('email')}
                  label={content.contact_form.email_label}
                  name="email"
                  type="email"
                  inputProps={{
                    required: true,
                    disabled: isLoading
                  }}
                  limitWidth={false}
                />
              </InputGroup>
              <InputGroup>
                <Select
                  value={values.subject}
                  name="subject"
                  title={content.contact_form.subject_label}
                  label={`* ${content.contact_form.subject_label}`}
                  onChange={(value) =>
                    onValueChange('subject')({ target: { value } })
                  }
                  options={[
                    {
                      value: 'general',
                      key: 'general',
                      title: content.contact_form.subjects.general,
                      label: content.contact_form.subjects.general
                    },
                    {
                      value: 'media',
                      key: 'media',
                      title: content.contact_form.subjects.media,
                      label: content.contact_form.subjects.media
                    }
                  ]}
                />
              </InputGroup>
              <InputGroup>
                <TextAreaInput
                  error={errors.message}
                  value={values.message}
                  onChange={onValueChange('message')}
                  label={content.contact_form.message_label}
                  name="message"
                  inputProps={{
                    required: true,
                    disabled: isLoading,
                    rows: 5
                  }}
                  limitWidth={false}
                  resize="vertical"
                />
              </InputGroup>
              {genericError && (
                <InputGroup>
                  <GenericError>
                    {content.contact_form.generic_error}
                  </GenericError>
                </InputGroup>
              )}
              <InputGroup align="right">
                <Button
                  tracking={{ label: 'contact_form_submit' }}
                  type="primary"
                  onClick={(e) => onSubmit(e, content)}
                  disabled={isLoading}
                >
                  {content.contact_form.submit_label}
                </Button>
              </InputGroup>
            </Form>
          )}
        </Fragment>
      )}
    />
  )
}
